import React, { ReactElement, useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import PremiumModal from "../premiumModal";
import ProModal from "../ProModal";
import { practiceSlugs } from "../../utils/commonRouteUrl";
import { getIsAdmin, getUserInfo } from "../../store/selector/userSelector";
import useUpgradePlanHook from "./useUpgradePlanHook";

type DropdownListTitleProps = {
  title: string | ReactElement;
  toolName: string;
  item: any;
  setShowSuggestions: any;
  setIsForm: any;
  setShow: any;
};

function DropdownBlogListTitle({ title, toolName, item, setShowSuggestions, setIsForm, setShow }: DropdownListTitleProps) {
  const [premiumMonthUpgradeModal, setPremiumMonthUpgradeModal] = useState(false);
  const [proMonthUpgradeModal, setProMonthUpgradeModal] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const userInfo: any = useSelector(getUserInfo);
  const isAuth = userInfo?.auth_token;
  const isAdmin = useSelector(getIsAdmin);

  const closeHeaderSearchDropdown = useCallback(() => {
    setIsForm(false);
    setShowSuggestions(false);
    setShow();
  }, [setIsForm, setShow, setShowSuggestions]);

  const { reviewerPageUpgradeModal, reviewerPageAccessCard } = useUpgradePlanHook(
    item,
    userInfo?.subscription_type,
    setPremiumMonthUpgradeModal,
    setProMonthUpgradeModal,
    isAdmin,
    isAuth,
    closeHeaderSearchDropdown,
  );

  const redirectUrl = useMemo(() => {
    return encodeURIComponent(`?redirect_url=${practiceSlugs?.previewTemplate(item?.id)}`);
  }, [item?.id]);

  return (
    <>
      <li
        aria-hidden
        onClick={() => {
          setIsForm(true);
          setShowSuggestions(true);
          reviewerPageUpgradeModal();
          reviewerPageAccessCard();
        }}
      >
        <span className="text-blue cursor-pointer me-2 fw-bold">{toolName}</span>
        <span className="cursor-pointer">{title}</span>
      </li>
      <PremiumModal
        isOpen={premiumMonthUpgradeModal}
        onClosed={() => {
          setIsForm(false);
          setShowSuggestions(false);
          setPremiumMonthUpgradeModal(false);
        }}
        title="Unlock Premium Features"
        content="Do you like what you’ve experienced so far? Unlock more potential:"
        price="$19.99"
        Flag="Month"
        submitBtn
        isFreeTrial={false}
        monthly={isMonthly}
        setMonthly={setIsMonthly}
        redirectUrl={redirectUrl}
      />
      <ProModal
        isOpen={proMonthUpgradeModal}
        onClosed={() => {
          setIsForm(false);
          setShowSuggestions(false);
          setProMonthUpgradeModal(false);
        }}
        title="Unlock Pro Features"
        content="Do you like what you’ve experienced so far? Unlock more potential:"
        price="$19.99"
        Flag="Month"
        submitBtn
        isFreeTrial={false}
        monthly={isMonthly}
        setMonthly={setIsMonthly}
        redirectUrl={redirectUrl}
      />{" "}
    </>
  );
}

export default DropdownBlogListTitle;
